import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Layout = ({ children, fullWidth }) => {
  return (
    <>
      <Navigation />
      <main>
        {fullWidth ? (
          <div className="full-width-content">{children}</div>
        ) : (
          <div className="container-content">{children}</div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default Layout; 